import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, getToken, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refreshUser = useCallback(async () => {
    if (!getToken()) return setUser(false);
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (_) {
      setToken(null);
      setUser(false);
    }
  }, []);

  useEffect(() => {
    refreshUser();
    const onLogout = () => setUser(false);
    window.addEventListener("tm-logout", onLogout);
    return () => window.removeEventListener("tm-logout", onLogout);
  }, [refreshUser]);

  const acceptSession = async (data) => {
    if (!data?.access_token) throw new Error("Account created. Please log in.");
    setToken(data.access_token);
    if (data.user) setUser(data.user);
    else await refreshUser();
    return data.user;
  };

  const login = async (identifier, password) => {
    const isEmail = identifier.includes("@");
    const { data } = isEmail
      ? await api.post("/auth/login", { email: identifier, password })
      : await api.post("/auth/mobile/login", { mobile_number: identifier, password });
    return acceptSession(data);
  };

  const logout = () => {
    setToken(null);
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, setUser, login, logout, refreshUser, acceptSession }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
